import { load } from '@iheartjane/utils';
import { Suspense } from 'react';

import { selectIdentification } from '@jane/monolith/customer/redux/identification';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { LoadingWrapper } from '@jane/shared/components';

import type { IdentificationProps } from './identification.types';
import { WarningMessage } from './warningMessage';

/** Code splitting to load convertIfPDF/pdfjs only when called */
const DeluxeIdentificationUploader = load(
  () => import('./idUploader'),
  'DeluxeIdentificationUploader'
);

export const StudentIdentification = ({
  showValidationErrors,
  valid,
  onIdUploadAttempt,
}: IdentificationProps) => {
  const { document, loading_student_photo } =
    useCustomerSelector(selectIdentification);

  if (!document) return null;

  return (
    <Suspense fallback={<LoadingWrapper isLoading />}>
      <DeluxeIdentificationUploader
        imageKey="student_photo"
        inputName="government-id"
        label="Upload Student ID"
        document={document}
        isLoading={loading_student_photo}
        valid={valid}
        showValidationErrors={showValidationErrors}
        onIdUploadAttempt={onIdUploadAttempt}
      />
      {!document.student_photo && (
        <WarningMessage>ID required for discount</WarningMessage>
      )}
    </Suspense>
  );
};
